module.exports = __webpack_public_path__ + "img/slide-img-04.a4a06e71.png";